import { array, object, string } from 'yup'
import * as R from 'ramda'
import { t } from 'ttag'

import { MODULES_FIELD } from './model'

export const getSchema = () =>
  object().shape({
    [MODULES_FIELD]: array()
      .of(
        object()
          .shape({ name: string() })
          .required(),
      )
      .test(
        'at-least-one-module',
        t`At least one module must be selected.`,
        modules => R.any(module => module[module.name] === R.T(), modules),
      ),
  })
